import { useNavigate, useLocation } from 'react-router-dom';
import { IconButton, makeStyles, Theme } from '@material-ui/core';
import EllisIcon from '../Root/icons/ellisIcon';
import { useFeatureFlags } from '../../hooks/useFeatureFlags';

const useStyles = makeStyles((theme: Theme) => ({
  ellisAiChatbot: {
    position: 'fixed',
    bottom: '20px',
    right: '20px',
    backgroundColor: theme.palette.primary.main,
    borderRadius: '50%',
    zIndex: 10,
    '&:hover': {
      backgroundColor: theme.palette.primary.dark,
    },
  },
  chatIcon: {
    '& span': {
      color: theme.palette.text.contrast,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
  },
}));

const EllisAiChatButton = () => {
  const classes = useStyles();
  const navigate = useNavigate();
  const location = useLocation();
  const { sidebarFeatures } = useFeatureFlags();

  // Check if Ellis AI D&T Chat is enabled in sidebar features
  const isEllisAiChatEnabled = sidebarFeatures.includes('Ellis AI D&T Chat');

  const handleClick = () => {
    navigate('/ellis-ai-dnt-chat');
  };

  // Don't show if not in sidebar features or if already on the page
  if (!isEllisAiChatEnabled || location.pathname === '/ellis-ai-dnt-chat') {
    return null;
  }

  return (
    <div className={classes.ellisAiChatbot} onClick={handleClick}>
      <IconButton
        className={classes.chatIcon}
        size="medium"
        title="Ellis AI Chat"
      >
        <EllisIcon />
      </IconButton>
    </div>
  );
};

export default EllisAiChatButton;
